/**
 * ゆめさくコードの共有画像。専用の絵を持たないページは全部これを出す。
 * エラー画面の行き先にも同じ絵を出すので、住所はここだけに置く
 */
export const SITE_OGP_IMAGE =
  "https://storage.chotdekiru.com/ogp/yumesaku_ogp_v2.png";
